import { useCallback } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import FitScreenIcon from '@/material-icons/400-24px/fit_screen.svg?react';
import FullscreenExitIcon from '@/material-icons/400-24px/fullscreen_exit.svg?react';
import { changeLocalSetting } from 'flavours/glitch/actions/local_settings';
import { IconButton } from 'flavours/glitch/components/icon_button';
import { useAppDispatch, useAppSelector } from 'flavours/glitch/store';

const messages = defineMessages({
  expand: { id: 'compose.expand_panel', defaultMessage: 'Agrandir la zone de composition' },
  collapse: { id: 'compose.collapse_panel', defaultMessage: 'Réduire la zone de composition' },
});

export const ExpandComposeButton = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const expanded = useAppSelector((state) => state.getIn(['local_settings', 'expanded_compose_panel']));

  const handleClick = useCallback(() => {
    dispatch(changeLocalSetting(['expanded_compose_panel'], !expanded));
  }, [dispatch, expanded]);

  const title = intl.formatMessage(expanded ? messages.collapse : messages.expand);

  return (
    <IconButton
      icon=''
      onClick={handleClick}
      iconComponent={expanded ? FullscreenExitIcon : FitScreenIcon}
      title={title}
      active={expanded}
      size={18}
      inverted
    />
  );
};
